"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartialDLNInputWithInfoQuestionWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var InfoQuestionCollapseWrapper_1 = require("../../components/infoQuestion/InfoQuestionCollapseWrapper");
var PartialDLNInputWithInfoQuestionWidget = exports.PartialDLNInputWithInfoQuestionWidget = /** @class */ (function (_super) {
    __extends(PartialDLNInputWithInfoQuestionWidget, _super);
    function PartialDLNInputWithInfoQuestionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnBlurEvent = function (event) {
            _this.handleDrivingLicenceNumberChange();
            _super.prototype.handleOnBlurEvent.call(_this, event);
        };
        _this.handleOnMonthPartChangeEvent = function (event) {
            // allow only numbers in month field
            var regExp = /^[0-9\b]+$/;
            if (event.target.value === '' || (regExp.test(event.target.value) && _this.checkMonthPart(event.target.value))) {
                _this.setState({
                    monthPart: event.target.value,
                });
            }
            _this.handleDrivingLicenceNumberChange();
        };
        _this.handleOnRandomPartChangeEvent = function (event) {
            _this.setState({
                randomPart: event.target.value
            });
            _this.handleDrivingLicenceNumberChange(event.target.value);
        };
        var interactionField = _this.bindFromField(_this.props.question.interactionField);
        _this.state = {
            monthPart: (interactionField && interactionField.length > 8) ? interactionField.slice(6, 8).toUpperCase() : "",
            randomPart: (interactionField && interactionField.length >= 16) ? interactionField.slice(12, 16).toUpperCase() : "",
            lastNamePart: "",
            yearDecadePart: "",
            dayYearPart: "",
            firstNamePart: "",
            titleQuestionPart: "",
            isChanged: false
        };
        return _this;
    }
    PartialDLNInputWithInfoQuestionWidget.prototype.render = function () {
        var label = this.props.question.label ? this.props.question.label : this.renderHtml(this.getSetting("labelHtml"));
        var info = this.renderHtml(this.getSetting("infoHtml"));
        return (React.createElement(InfoQuestionCollapseWrapper_1.InfoQuestionCollapseWrapper, { label: label, info: info },
            this.renderInputField(),
            this.renderValidationResult()));
    };
    PartialDLNInputWithInfoQuestionWidget.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (this.state.isChanged) {
            this.handleDrivingLicenceNumberChange();
        }
    };
    PartialDLNInputWithInfoQuestionWidget.prototype.renderInputField = function () {
        this.updateStateFromInteractionFields();
        return (React.createElement("div", { className: "dl-part-flex" },
            React.createElement("p", { className: "m-auto" },
                this.state.lastNamePart || "#####",
                this.state.yearDecadePart || "#"),
            React.createElement("input", { type: "text", className: "form-control ".concat(this.getInputValidationClass(), " w-50px"), id: this.props.question.name + "monthPart", placeholder: this.props.question.placeHolder, value: this.state.monthPart, onInput: this.handleOnMonthPartChangeEvent, onFocus: this.executeNativeEvent, maxLength: 2, minLength: 2, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, readOnly: this.isReadOnly() }),
            React.createElement("p", { className: "m-auto" },
                this.state.dayYearPart || "###",
                this.state.firstNamePart || "#"),
            React.createElement("input", { type: "text", className: "form-control ".concat(this.getInputValidationClass(), " dl-part-last-input"), id: this.props.question.name + "randomPart", placeholder: this.props.question.placeHolder, value: this.state.randomPart, onChange: this.handleOnRandomPartChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, maxLength: 4, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, readOnly: this.isReadOnly() })));
    };
    PartialDLNInputWithInfoQuestionWidget.prototype.updateStateFromInteractionFields = function () {
        var title = this.getInteractionValuesFromSettings("title");
        if (title) {
            if (this.state.titleQuestionPart !== title) {
                this.setState({
                    titleQuestionPart: title,
                    isChanged: true
                });
            }
        }
        var lastname = this.getInteractionValuesFromSettings("lastName");
        if (lastname) {
            lastname = lastname.replace(/[- '`]/g, '');
            var lastNamePartValue = this.processLastNameValidation(lastname.length >= 5 ? lastname.slice(0, 5).toUpperCase() : lastname.toUpperCase());
            if (this.state.lastNamePart !== lastNamePartValue) {
                this.setState({
                    lastNamePart: lastNamePartValue,
                    isChanged: true
                });
            }
        }
        var dateOfBirth = this.getInteractionValuesFromSettings("dateOfBirth");
        if (dateOfBirth) {
            var yearDecadePartValue = this.replaceMissingValuesWithHash(dateOfBirth.length >= 3 ? dateOfBirth.slice(2, 3).toUpperCase() : "", 1);
            var monthOfBirthPartValue = dateOfBirth.length >= 9 ? dateOfBirth.slice(5, 7).toUpperCase() : "";
            var dayOfBirthPartValue = dateOfBirth.length >= 9 ? dateOfBirth.slice(8, 10).toUpperCase() : "";
            var yearOfBirthPartValue = dateOfBirth.length >= 9 ? dateOfBirth.slice(0, 4).toUpperCase() : "";
            // this.state.dateMonth is not actually used anymore, but let's maintain it for consistency with day and year
            if (this.state.dateMonth !== monthOfBirthPartValue) {
                this.setState({
                    dateMonth: monthOfBirthPartValue,
                    isChanged: true
                });
            }
            if (this.state.dateDay !== dayOfBirthPartValue) {
                this.setState({
                    dateDay: dayOfBirthPartValue,
                    isChanged: true
                });
            }
            if (this.state.dateYear !== yearOfBirthPartValue) {
                this.setState({
                    dateYear: yearOfBirthPartValue,
                    isChanged: true
                });
            }
            if (this.state.yearDecadePart !== yearDecadePartValue) {
                this.setState({
                    yearDecadePart: yearDecadePartValue,
                    isChanged: true
                });
            }
            var dayYearPartValue = this.replaceMissingValuesWithHash(dateOfBirth.length >= 10 ? dateOfBirth.slice(8, 10).toUpperCase() + dateOfBirth.slice(3, 4).toUpperCase() : "", 3);
            if (this.state.dayYearPart !== dayYearPartValue) {
                this.setState({
                    dayYearPart: dayYearPartValue,
                    isChanged: true
                });
            }
        }
        var firstName = this.getInteractionValuesFromSettings("firstName");
        if (firstName) {
            var firstNamePartValue = this.replaceMissingValuesWithHash(firstName.length >= 1 ? firstName.slice(0, 1).toUpperCase() : firstName.toUpperCase(), 1);
            if (this.state.firstNamePart !== firstNamePartValue) {
                this.setState({
                    firstNamePart: firstNamePartValue,
                    isChanged: true
                });
            }
        }
    };
    PartialDLNInputWithInfoQuestionWidget.prototype.getInteractionValuesFromSettings = function (setting) {
        var settingPath = this.getSetting(setting);
        if (!settingPath) {
            throw new Error("Widget ".concat(this.props.question.name, " is not configured properly - ").concat(setting, " should be set."));
        }
        return this.bindFromField(settingPath);
    };
    PartialDLNInputWithInfoQuestionWidget.prototype.replaceMissingValuesWithHash = function (initValue, hashesToAppend) {
        var hashes = "";
        for (var i = initValue.length; i < hashesToAppend; i++) {
            hashes += "#";
        }
        return initValue + hashes;
    };
    PartialDLNInputWithInfoQuestionWidget.prototype.processLastNameValidation = function (lastNamePartValue) {
        var validDLLastNamePart = lastNamePartValue;
        if (lastNamePartValue.length < 5) {
            for (var i = lastNamePartValue.length; i < 5; i++) {
                validDLLastNamePart = validDLLastNamePart + "9";
            }
        }
        if (lastNamePartValue.toUpperCase().startsWith("MAC")) {
            if (lastNamePartValue.length >= 6) {
                validDLLastNamePart = "MC" + validDLLastNamePart.substring(3, 6).toUpperCase();
            }
            else {
                validDLLastNamePart = "MC" + validDLLastNamePart.substring(3).toUpperCase();
                for (var i = validDLLastNamePart.length; i < 5; i++) {
                    validDLLastNamePart = validDLLastNamePart + "9";
                }
            }
        }
        return validDLLastNamePart;
    };
    PartialDLNInputWithInfoQuestionWidget.prototype.checkMonthPart = function (montPart) {
        return !((parseInt(montPart, 10) > 12 && parseInt(montPart, 10) < 51) ||
            parseInt(montPart, 10) > 62 ||
            montPart === "00" ||
            montPart[0] === "2" ||
            montPart[0] === "3" ||
            montPart[0] === "4" ||
            montPart[0] === "7" ||
            montPart[0] === "8" ||
            montPart[0] === "9");
    };
    // State changes are too slow and thus the value is passed on directly
    PartialDLNInputWithInfoQuestionWidget.prototype.handleDrivingLicenceNumberChange = function (randomPart) {
        if (randomPart == undefined)
            randomPart = this.state.randomPart;
        var drivingLicenceNumber = this.state.lastNamePart + this.state.yearDecadePart + this.state.monthPart +
            this.state.dayYearPart + this.state.firstNamePart + randomPart;
        if (drivingLicenceNumber.length === 16 && !drivingLicenceNumber.includes("#")) {
            this.props.onStateChange(this.props.question.interactionField, drivingLicenceNumber);
        }
        else {
            this.props.onStateChange(this.props.question.interactionField, "");
        }
        if (this.state.isChanged) {
            this.setState({
                isChanged: false
            });
        }
    };
    PartialDLNInputWithInfoQuestionWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "infoHtml", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], PartialDLNInputWithInfoQuestionWidget);
    return PartialDLNInputWithInfoQuestionWidget;
}(plugin_journey_1.QuestionWidgetBase));
//# sourceMappingURL=PartialDLNInputWithInfoQuestionWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/PartialDLNInputWithInfoQuestionWidget.js
// module id = 3439
// module chunks = 0